export const ABS_SHARED = {
  DATES: {
    RAW_DATE_FORMAT: 'yyyyMMdd',
    PAST_YEARS_OFFSET: 110,
    FUTURE_YEARS_OFFSET: 30,
    COMMON_DATE_FORMATS: ['dd/MM/yyyy', 'MM/dd/yyyy', 'yyyy/MM/dd'],
  },
} as const
